import React from 'react';
import { css } from 'aphrodite/no-important';

import Media from '../Media';
import style from './styles';

const MediaSplit = ({ leftImg, rightImg }) => (
  <div className={ css(style.container) }>
    <Media
      type="img"
      customStyles={ style.imgLeft }
      src={ leftImg }
    />

    <Media
      type="img"
      customStyles={ style.imgRight }
      src={ rightImg }
    />
   </div> 
);

MediaSplit.propTypes = {
  leftImg: React.PropTypes.string.isRequired,
  rightImg: React.PropTypes.string.isRequired,
};

export default MediaSplit;



// WEBPACK FOOTER //
// ./src/components/MediaSplit/index.js